import { cn } from "@reactive-resume/utils";

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("bg-secondary animate-pulse rounded-md", className)} {...props} />
);
